// eslint-disable-next-line
import Vuex from 'vuex';
import store from '@/store';
import exportApiClient from '@/services/apiServices/exportApiClient.js'
import referenceApiClient from '@/services/apiServices/referenceApiClient.js'

//***
//This file integrates the VueCadPlugin into the fusion360 client
//It uses the adsk service injected by the fusion360 webclient to communicate with the fusion360 software
//This service is not immediately available, so an interval is tied to browser events to await the service's availability
//Any actions fired that are relevant to the client before the service is avialable are stored, and then executed sequentially once it is available
//***//

//stores any actions fired before service is available.
var adskQueue = [];

//handles actual interaction with the adsk service once it is injected
function sendInfoToFusion(query, args) {
    //Replacement for: adsk.fusionSendData('send', JSON.stringify(args));
    //neutronJavaScriptObject.executeQuery(query, JSON.stringify(args));
    // eslint-disable-next-line
    return adsk.fusionSendData(query, JSON.stringify(args));
}

//checks for adsk availability once called
function checkADSK() {
    const adskWaiter = setInterval(function () {
        // eslint-disable-next-line
        if (typeof adsk !== 'undefined') {
            clearInterval(adskWaiter);
            while (adskQueue.length > 0) {
                var act = adskQueue.pop();
                store.dispatch(act.action.type, act.action.payload);
            }
        }
    }, 500);
}

//Establishes functions to be available externally as a service
const Fusion360Service = {
    in_tool_check() {
        if (window.adsk)
            return true;
        return false;
    },
    get_client_version() { 
        //V1 lacks version support and reports incorrect commands via message box, check if V1 exclusive command exists to check that version
        var v1Args = {};
        var v1Call = sendInfoToFusion('getPreferences', v1Args);
        return v1Call.then(data => {
            var v1Check = JSON.parse(data);

            if (v1Check && v1Check.success) {
                return 1;
            }
            else if (v1Check && !v1Check.success && v1Check.error_code == 1) //Version support exists and can be used
            {
                var args = {};
                var ret = sendInfoToFusion('getClientVersion', args);

                return ret.then(data => {
                    var retval = JSON.parse(data);
                    if (retval && retval.success) {
                        return JSON.parse(retval.version);
                    } else {
                        return 0; //version support exists but was not found
                    }
                });
            } else {
                return -1; //version support not found
            }
        });
    },
    get_user_profile() {
        var args = {};
        var ret = sendInfoToFusion('getPreferences', args); //check v1 preference

        return ret.then(data => {
            var retval = JSON.parse(data);

            if (retval && retval.success) {
                return JSON.parse(retval.data);
            } else if (retval && retval.error_code == 1) {
                var ret2 = sendInfoToFusion('getLocalPreferences', args); //check v2+ preferences

                return ret2.then(data2 => {
                    var parseVal2 = JSON.parse(data2);
                    if (parseVal2 && parseVal2.success) {
                        var profile = JSON.parse(parseVal2.data);
                        return profile;
                    } else {
                        return [];
                    }
                });
            }
        });
    },
    set_user_profile(setProfile) {
        var ret = sendInfoToFusion('setPreferences', setProfile); //attempt to set v1 preference
        return ret.then(data => {
            var retval = JSON.parse(data);
            if (retval && retval.success == false && retval.error_code == 1) {
                return sendInfoToFusion('setLocalPreferences', setProfile); //attempt to set v2+ preferences
            }
        });

    },
    open_url(url) {
        var args = {
            url: url
        };
        sendInfoToFusion('openUrl', args);
    },
    async get_open_libraries() {
        var args = {};
        var ret = await sendInfoToFusion('getOpenLibraries', args);

        var retval = JSON.parse(ret);
        if (retval && retval.success) {
            var item = retval.openlibraries;
            return item;
        } else {
            //kick off active library failure
            store.commit('SET_GLOBAL_ERROR', 'Open Library Failure');
            return null;
        }
    },
    async get_active_library() {
        var args = {};
        var ret = await sendInfoToFusion('getOpenLibraries', args);

        var retval = JSON.parse(ret);
        if (retval && retval.success) {
            var item = retval.openlibraries.filter(library => library.isActive == true);
            return item;
        } else {
            //kick off active library failure
            store.commit('SET_GLOBAL_ERROR', 'Active Library Failure');
            return null;
        }
    }
}

//defines the web prefix that uses this file
const InstanceName = 'fusion360';

//Defines the plugin used to attach to events once in tool.
const FusionPlugin = store => {
    store.subscribeAction(async (action, state) => {
        //if instance matched but tool access is not, store action for later running.
        // eslint-disable-next-line
        if (state && state.instance && state.instance.toLowerCase() == InstanceName && !(typeof (adsk) !== 'undefined' && adsk !== null)) {
            //Attaches to an available event to start firing off the checkADSK function in any of the possible browsers within fusion360
            if (adskQueue.length == 0) {
                if (window.addEventListener)
                    window.addEventListener("load", checkADSK, false);
                else if (window.attachEvent)
                    window.attachEvent("onload", checkADSK);
                else window.onload = checkADSK;
            }
            adskQueue.push({ action });
        }

        //if instance matched and tool access is matched execute the actions
        if (Fusion360Service.in_tool_check() && state.instance && state.instance.toLowerCase() == InstanceName) {
            var baseVersionContent = await Fusion360Service.get_client_version();
            if (baseVersionContent) {
                store.commit('GET_VERSION', baseVersionContent);
            }

            switch (action.type) {
                case 'refreshProfile':
                    //Pull the profile as defined by the tool
                    var refreshContent = await Fusion360Service.get_user_profile();
                    if (refreshContent) {
                        store.commit('GET_PROFILE', refreshContent);
                    }
                    //var versionContent = await Fusion360Service.get_client_version();
                    //if (versionContent) {
                    //    store.commit('GET_VERSION', versionContent);
                    //}
                    break;
                case 'goToStart':
                    //var startVersionContent = await Fusion360Service.get_client_version();
                    //if (startVersionContent) {
                    //    store.commit('GET_VERSION', startVersionContent);
                    //}
                    break;
                case 'getLibraryDropdown':
                    var openLibraries = await Fusion360Service.get_open_libraries();
                    store.commit('SET_OPEN_LIBRARIES', openLibraries);
                    break;
                case 'setUserProfile':
                    //Push the current in plugin profile value to the tool to store
                    await Fusion360Service.set_user_profile(action.payload);
                    // eslint-disable-next-line
                    var setUserProfile = await Fusion360Service.get_user_profile();
                    store.commit('GET_PROFILE', setUserProfile);
                    break;
                case 'getActiveLibrary':
                    var librarySource = await Fusion360Service.get_active_library();
                    if (librarySource) {
                        var activeLibraries = librarySource.filter((library) => library.isActive == true);
                        if (activeLibraries && activeLibraries.length > 0 && activeLibraries[0].isActive) {
                            var activeProfile = { name: 'Open Library: ' + activeLibraries[0].projectName + ' - ' + activeLibraries[0].libraryName, project: { id: activeLibraries[0].projectId, name: activeLibraries[0].projectName }, library: { id: activeLibraries[0].libraryId, name: activeLibraries[0].libraryName } };
                            var activeValid = activeLibraries[0] != null && activeLibraries[0].isActive;
                            store.commit('SET_ACTIVE_LIBRARY', { profile: activeProfile, valid: activeValid });
                        } else {
                            store.commit('SET_ACTIVE_LIBRARY', { profile: null, valid: false });
                        }
                    } else {
                        store.commit('SET_ACTIVE_LIBRARY', { profile: null, valid: false });
                    }
                    break;
                case 'selectPart':
                    break;
                case 'downloadComplete':
                    //when the download is available process passing the content to the tool
                    exportApiClient.Download(store.state.export.token).then((response) => {
                        //grab current target library from profile
                        if (response.data.success) {
                            var libId = null;
                            var projId = null;
                            var profile = store.state.activeProfile;
                            if (store.state.export.useActive && profile != null) {
                                libId = profile.library.id;
                                projId = profile.project.id;
                            }

                            var ret = {
                                "libraryId": libId,
                                "projectId": projId,
                                "encodedUlZip": response.data.fileContent,
                                "deviceName": response.data.partName
                            };
                            sendInfoToFusion('downloadUlDevice', ret);

                        } else {
                            //kick off general error notification
                            store.commit('SET_GLOBAL_ERROR', 'Download Failure');
                        }
                    });
                    break;
                case 'downloadReference':
                    var downloadLocation = store.state.profile.downloadLocation;
                    //check non-null profile here
                    if (downloadLocation && downloadLocation != '') {
                        referenceApiClient.Download(action.payload).then((response) => {
                            //grab current target library from profile
                            if (response.data.found) {
                                var ret = {
                                    "encodedSchZip": response.data.fileContent,
                                    "designName": response.data.fileName,
                                    "downloadDir": downloadLocation
                                };
                                sendInfoToFusion('downloadReferenceDesign', ret).then((retVal) => {
                                    var failcheck = JSON.parse(retVal);
                                    if (!failcheck.success) {
                                        store.commit('SET_GLOBAL_ERROR', 'Permission to create directory for Reference Design Denied.');
                                    }
                                });
                            } else {
                                //kick off general error notification
                                store.commit('SET_GLOBAL_ERROR', 'Download Reference Design Not Found');
                            }

                        }).catch(() => {
                            store.commit('SET_GLOBAL_ERROR', 'Download Reference Design Failure');
                        });
                    } else {
                        //kick off profile error notification
                        store.commit('SET_GLOBAL_ERROR', 'Download Location must be defined in the user profile to download Reference Designs');
                        //How to link to the control from here?
                    }
                    break;
                case 'openUrl':
                    //Open External Url
                    await Fusion360Service.open_url(action.payload.url);
                    break;
            }
        }
    });


    //window.fusionJavaScriptHandler = {
    //    handle: function (action, data) {
    //        alert("Send command from Fusion360")
    //        alert("action: " + JSON.stringify(action));
    //        alert("data: " + JSON.stringify(data));
    //        try {
    //            if (action == 'send') {
    //                alert("Send command from Fusion360")
    //            }
    //            else if (action == 'debugger') {
    //                debugger;
    //            }
    //            else {
    //                return 'Unexpected command type: ' + action;
    //            }
    //        } catch (e) {
    //            console.log(e);
    //            console.log('exception caught with command: ' + action + ', data: ' + data);
    //        }
    //        return 'OK';
    //    }
    //};
}

export { Fusion360Service, FusionPlugin };